import { NavLink } from "react-router-dom";
import { ROUTE_META } from "../../../navigation/routeMeta";
import { useSidebarBadges } from "../../../navigation/useSidebarBadges";
import { useMockDataVersion } from "../../../data/mockDataStore";

const badgeClass = (key) => {
  if (key === "resa") return "nav-badge nav-badge-warn";
  if (key === "tickets") return "nav-badge nav-badge-danger";
  return "nav-badge";
};

export function Sidebar({ open, collapsed }) {
  useMockDataVersion();
  const badges = useSidebarBadges();

  return (
    <aside
      className={`sidebar${open ? " open" : ""}${collapsed ? " collapsed" : ""}`}
      id="sidebar"
      data-testid="sidebar"
    >
      <div className="sidebar-brand">
        <div className="brand-mark">
          <svg viewBox="0 0 32 32" width="28" height="28" aria-hidden="true">
            <defs>
              <linearGradient id="g1" x1="0" x2="1" y1="0" y2="1">
                <stop offset="0" stopColor="#4F46E5" />
                <stop offset="1" stopColor="#0D9488" />
              </linearGradient>
            </defs>
            <rect x="2" y="2" width="28" height="28" rx="8" fill="url(#g1)" />
            <path d="M9 21 L16 10 L23 21 Z" fill="#fff" opacity=".95" />
            <circle cx="16" cy="20" r="1.8" fill="#fff" />
          </svg>
        </div>
        <div className="brand-text">
          <div className="brand-name">vivaPilot</div>
          <div className="brand-sub">Support &amp; Ops</div>
        </div>
      </div>

      <nav className="sidebar-nav" id="sidebarNav" data-testid="sidebar-nav">
        {ROUTE_META.map((route) => (
          <NavLink
            key={route.key}
            className={({ isActive }) => `nav-item${isActive ? " active" : ""}`}
            to={route.path}
            data-testid={`nav-${route.key}`}
          >
            <i className={route.icon}></i>
            <span>{route.label}</span>
            {route.badgeKey && badges[route.badgeKey] > 0 ? (
              <span className={badgeClass(route.badgeKey)} id={`badge-${route.badgeKey}`}>
                {badges[route.badgeKey]}
              </span>
            ) : null}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}

export default Sidebar;
